import { map, find, findIndex, chunk } from 'lodash';
import md5 from 'md5';

// css控制器
let styleSheetNode = null;
const colorControllerId = 'query-highlight-controller__styleSheet';
const disableStyle = 'background-color: unset !important;';


/**
 * 高亮class名字
 * patsnap-search-hit-0
 * .....
 * patsnap-search-hit-4
 * patsnap-search-hit
 */
const highlightBaseClassName = 'patsnap-search-hit';


//目前最多定义了6种颜色(后端高亮), 其中一种是是固定默认的颜色
const maxColorTypes = 5;


//最多记录n条不同query
const maxHistoryLength = 20;


//高亮配色
const colorSetting = {
    '0': 'background-color: #FFC2C2;',
    '1': 'background-color: #C5ADFF;',
    '2': 'background-color: #94D0F7;',
    '3': 'background-color: #F7793E;',
    '4': 'background-color: #F5DB36;',
    'other': 'background-color: #BAE6A3;'
};
const highlightMap = {
    '0': {
        selectedClass: `.${highlightBaseClassName}-0{${colorSetting['0']}}`,
        notSelectedClass: `.${highlightBaseClassName}-0{${disableStyle}}`,
    },
    '1': {
        selectedClass: `.${highlightBaseClassName}-1{${colorSetting['1']}}`,
        notSelectedClass: `.${highlightBaseClassName}-1{${disableStyle}}`,
    },
    '2': {
        selectedClass: `.${highlightBaseClassName}-2{${colorSetting['2']}}`,
        notSelectedClass: `.${highlightBaseClassName}-2{${disableStyle}}`,
    },
    '3': {
        selectedClass: `.${highlightBaseClassName}-3{${colorSetting['3']}}`,
        notSelectedClass: `.${highlightBaseClassName}-3{${disableStyle}}`,
    },
    '4': {
        selectedClass: `.${highlightBaseClassName}-4{${colorSetting['4']}}`,
        notSelectedClass: `.${highlightBaseClassName}-4{${disableStyle}}`,
    },
    'other': {
        selectedClass: `.${highlightBaseClassName}{${colorSetting['other']}}`,
        notSelectedClass: `.${highlightBaseClassName}{${disableStyle}}`,
    },
};


/**
 * 记录用户选中高亮字段的状态(query为key)
 */
const queryHighlightSelectedStorage = 'BackendHighlight__selectedData';
const queryKey = 'query-highlight-key__current-query';

//转换query: 防止存储超长字符的query
function encodeQuery(query) {
    return query ? md5(query) : '';
}
function setQueryHighlightSelectedStorage (query, fieldSelectedMap = {}) {
    try {
        if (!query) return;
        const iQuery = encodeQuery(query);
        const baseData = {
            ...fieldSelectedMap,
            [queryKey]: iQuery
        };

        const _storage = localStorage.getItem(queryHighlightSelectedStorage);
        const allData = _storage ? JSON.parse(_storage) : [];

        const historyIndex = findIndex(allData, { [queryKey]: iQuery });
        if (historyIndex !== -1) {
            const historyData = allData[historyIndex];
            allData.splice(historyIndex, 1);
            allData.push({
                ...historyData,
                ...baseData
            });
        } else {
            allData.push(baseData);
        }

        //只记录最近n条的数据
        allData.reverse();
        const newHistoryData = chunk(allData, maxHistoryLength)[0];
        newHistoryData.reverse();
        localStorage.setItem(queryHighlightSelectedStorage, JSON.stringify(newHistoryData));
    } catch (e) {
        console.warn(e);
    }
}
function getQueryHighlightSelectedStorage (query) {
    const iQuery = encodeQuery(query);
    const _storage = localStorage.getItem(queryHighlightSelectedStorage);
    if (_storage && iQuery) {
        let historyData = null;
        try {
            const allData = JSON.parse(_storage); // Array
            historyData = find(allData, { [queryKey]: iQuery }) || {};
        } catch (e) {
            historyData = {};
        }
        return historyData;
    }
    return {};
}

/**
 * 更新高亮style的控制器
 */
function initStyleController (colors, isReset) {
    styleSheetNode = document.querySelector(`#${colorControllerId}`);
    if (isReset || !styleSheetNode) {
        // remove
        if (styleSheetNode) {
            styleSheetNode.parentNode.removeChild(styleSheetNode);
        }
        //create
        styleSheetNode = document.createElement('style');
        styleSheetNode.id = colorControllerId;
        document.body.appendChild(styleSheetNode);
    }
    const styleList = map(colors, ({ isSelected, highlightMapKey }) => {
        const { selectedClass, notSelectedClass } = highlightMap[highlightMapKey];
        const itemStyle = isSelected ? selectedClass : notSelectedClass;
        return itemStyle;
    });
    styleSheetNode.innerHTML = styleList.join('\n');
}


export default {
    maxColorTypes,
    colorSetting,
    getQueryHighlightSelectedStorage,
    setQueryHighlightSelectedStorage,
    initStyleController
};
